import React, { useContext } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import FormattedCurrencyContainer from '../../../../../components/formatted-currency/container';
import { ArchiveContext } from '../../archive-context';
import { messages } from '../../messages';
import style from '../../style.module.less';

const ArchiveOrderTotalColumn = ({ archiveId }) => {
  const { archives } = useContext(ArchiveContext);
  const archiveOrderTotal = archives[archiveId]?.orderTotal;
  return (
    <div className={classnames(style['item-cell'], style['number-cell'])}>
      <FormattedCurrencyContainer currencyCode={archiveOrderTotal?.code} value={archiveOrderTotal?.value} />
    </div>
  );
};

ArchiveOrderTotalColumn.propTypes = {
  archiveId: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: () => <FormattedMessage {...messages.archiveOrderTotal} />,
  id: 'archiveOrderTotal',
  render: ArchiveOrderTotalColumn,
};
